import {
  COMPLIANCE_DOCUMENT_TYPE_INSURANCE_CERTIFICATE,
  COMPLIANCE_DOCUMENT_TYPE_LICENSE,
} from '@/constants/complianceDocuments';

const INSURANCE_TERMINOLOGY = {
  category: 'Insurance Type',
  issuerName: 'Insurance Company',
  email: 'Insurance Email',
  phone: 'Insurance Phone',
  status: 'Coverage Status',
  period: 'Coverage Period',
  verificationStatus: 'Coverage Verification Status',
  verificationRequired: 'Coverage Verification Required',
  verificationActionTitle: 'Verify the insurance coverage',
  verificationActionButton: 'Verify Coverage',
  verificationEmailTitle: 'Send coverage verification email',
  coverageEmailTitle: 'Send Coverage Expiration Reminder Email',
  renewCoverageButton: 'Renew Coverage',
  previousCoverageTab: 'Previous Coverage',
  coverageVerificationTab: 'Coverage Verification',
  verificationHistoryTitle: 'Coverage Verification History',
  expiryReminderText: 'before coverage expires.',
  endDateValidationText: 'Please enter a coverage end date.',
  coverage: 'Coverage',
  startDateLabel: 'Coverage Start',
  endDateLabel: 'Coverage End *',
  requiresVerificationLabel: 'Does this compliance document require coverage verification?',
  reminderDaysHelpText: 'This determines the number of days before the certificate expires to send reminder emails.',
};

const LICENSE_TERMINOLOGY = {
  category: 'License Type',
  issuerName: 'Issuing Authority',
  email: 'Authority Email',
  phone: 'Authority Phone',
  status: 'License Status',
  period: 'License Period',
  verificationStatus: 'License Verification Status',
  verificationRequired: 'License Verification Required',
  verificationActionTitle: 'Verify the license',
  verificationActionButton: 'Verify License',
  verificationEmailTitle: 'Send license verification email',
  coverageEmailTitle: 'Send License Expiration Reminder Email',
  renewCoverageButton: 'Renew License',
  previousCoverageTab: 'Previous Licenses',
  coverageVerificationTab: 'License Verification',
  verificationHistoryTitle: 'License Verification History',
  expiryReminderText: 'before license expires.',
  endDateValidationText: 'Please enter a license expiry date.',
  startDateLabel: 'License Start',
  endDateLabel: 'License Expiry *',
  coverage: '',
  requiresVerificationLabel: 'Does this compliance document require license verification?',
  reminderDaysHelpText: 'This determines the number of days before the license expires to send reminder emails.',
};

export default function complianceDocumentTerminology(documentType) {
  if (documentType === COMPLIANCE_DOCUMENT_TYPE_LICENSE) {
    return LICENSE_TERMINOLOGY;
  }

  if (documentType === COMPLIANCE_DOCUMENT_TYPE_INSURANCE_CERTIFICATE) {
    return INSURANCE_TERMINOLOGY;
  }

  return INSURANCE_TERMINOLOGY;
}
